import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SupportImgViewPage } from './support-img-view.page';

const routes: Routes = [
  {
    path: '',
    component: SupportImgViewPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupportImgViewPageRoutingModule {}
